import { Routes } from '@angular/router';
import { roleGuard } from './guards/role-guard.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'profile',
    pathMatch: 'full',
  },
  {
    path: 'candidates/:candidateId',
    loadComponent: () =>
      import('./pages/candidate/candidate.page').then((c) => c.CandidatePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'edit-process-design/:designUuid',
    loadComponent: () =>
      import('./pages/edit-process-design/edit-process-design.page').then(
        (c) => c.EditProcessDesignPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'message-listeners/:messageListenerFormGroupId',
    loadComponent: () =>
      import('./pages/message-listener/message-listener.page').then(
        (c) => c.MessageListenerPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'my-tasks/:userTaskFormGroupId',
    loadComponent: () =>
      import('./pages/my-task/my-task.page').then((c) => c.MyTaskPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'org-structure-levels/:orgStructureLevelId',
    loadComponent: () =>
      import('./pages/org-structure-level/org-structure-level.page').then(
        (c) => c.OrgStructureLevelPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'organizations/:organizationId',
    loadComponent: () =>
      import('./pages/organization/organization.page').then(
        (c) => c.OrganizationPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'persons/:userId',
    loadComponent: () =>
      import('./pages/person/person.page').then((c) => c.PersonPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'positions/:positionId',
    loadComponent: () =>
      import('./pages/position/position.page').then((c) => c.PositionPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-designs/:processDesignFormGroupId',
    loadComponent: () =>
      import('./pages/process-design/process-design.page').then(
        (c) => c.ProcessDesignPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-instances/:processInstanceFormGroupId',
    loadComponent: () =>
      import('./pages/process-instance/process-instance.page').then(
        (c) => c.ProcessInstancePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'service-tasks/:serviceTaskFormGroupId',
    loadComponent: () =>
      import('./pages/service-task/service-task.page').then(
        (c) => c.ServiceTaskPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'staff-types/:staffTypeId',
    loadComponent: () =>
      import('./pages/staff-type/staff-type.page').then((c) => c.StaffTypePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'timers/:timerFormGroupId',
    loadComponent: () =>
      import('./pages/timer/timer.page').then((c) => c.TimerPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'tokens/:tokenFormGroupId',
    loadComponent: () =>
      import('./pages/token/token.page').then((c) => c.TokenPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'user-tasks/:userTaskFormGroupId',
    loadComponent: () =>
      import('./pages/user-task/user-task.page').then((c) => c.UserTaskPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'venues/:venueId',
    loadComponent: () =>
      import('./pages/venue/venue.page').then((c) => c.VenuePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./pages/admin/admin.page').then((c) => c.AdminPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'application-status',
    loadComponent: () =>
      import('./pages/application-status/application-status.page').then(
        (c) => c.ApplicationStatusPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'candidates',
    loadComponent: () =>
      import('./pages/candidates/candidates.page').then(
        (c) => c.CandidatesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'configuration',
    loadComponent: () =>
      import('./pages/configuration/configuration.page').then(
        (c) => c.ConfigurationPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((c) => c.HomePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((c) => c.LoginPage),
    pathMatch: 'full',
  },
  {
    path: 'manage-interviews',
    loadComponent: () =>
      import('./pages/manage-interviews/manage-interviews.page').then(
        (c) => c.ManageInterviewsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'manage-roles',
    loadComponent: () =>
      import('./pages/manage-roles/manage-roles.page').then(
        (c) => c.ManageRolesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'my-tasks',
    loadComponent: () =>
      import('./pages/my-tasks/my-tasks.page').then((c) => c.MyTasksPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./pages/not-authorized/not-authorized.page').then(
        (c) => c.NotAuthorizedPage,
      ),
    pathMatch: 'full',
  },
  {
    path: 'org-structure-levels',
    loadComponent: () =>
      import('./pages/org-structure-levels/org-structure-levels.page').then(
        (c) => c.OrgStructureLevelsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'organizations',
    loadComponent: () =>
      import('./pages/organizations/organizations.page').then(
        (c) => c.OrganizationsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'persons',
    loadComponent: () =>
      import('./pages/persons/persons.page').then((c) => c.PersonsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'positions',
    loadComponent: () =>
      import('./pages/positions/positions.page').then((c) => c.PositionsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-admin',
    loadComponent: () =>
      import('./pages/process-admin/process-admin.page').then(
        (c) => c.ProcessAdminPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-admins',
    loadComponent: () =>
      import('./pages/process-admins/process-admins.page').then(
        (c) => c.ProcessAdminsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-designs',
    loadComponent: () =>
      import('./pages/process-designs/process-designs.page').then(
        (c) => c.ProcessDesignsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-instances',
    loadComponent: () =>
      import('./pages/process-instances/process-instances.page').then(
        (c) => c.ProcessInstancesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/profile/profile.page').then((c) => c.ProfilePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'service-tasks',
    loadComponent: () =>
      import('./pages/service-tasks/service-tasks.page').then(
        (c) => c.ServiceTasksPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'staff-types',
    loadComponent: () =>
      import('./pages/staff-types/staff-types.page').then(
        (c) => c.StaffTypesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'switch-user',
    loadComponent: () =>
      import('./pages/switch-user/switch-user.page').then(
        (c) => c.SwitchUserPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'user-tasks',
    loadComponent: () =>
      import('./pages/user-tasks/user-tasks.page').then((c) => c.UserTasksPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'venues',
    loadComponent: () =>
      import('./pages/venues/venues.page').then((c) => c.VenuesPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
];
